// extracted by mini-css-extract-plugin
export default {"gamesSliderWrap":"styles_gamesSliderWrap__w8Rwb"};